var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78666 14V7.43079H-0.000274658V5.06556H1.78666V3.04535C1.78666 1.45785 2.84222 0 5.27443 0C6.2592 0 6.98738 0.09177 6.98738 0.09177L6.93001 2.30049C6.93001 2.30049 6.18737 2.29347 5.37697 2.29347C4.49988 2.29347 4.35936 2.68638 4.35936 3.33851V5.06556H6.99973L6.88484 7.43079H4.35936V14H1.78666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    fill: "white",
    transform: "translate(-0.000274658)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.5244ba9804d093471d5c80c45d1e0bf6.svg";
export { ForwardRef as ReactComponent };